import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FieldHookConfig, useField } from 'formik';
import { ReactNode } from 'react';
import { HtmlTypography } from 'src/components/HtmlTypography';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { Tooltip } from 'src/components/Tooltip';
import { Typography } from 'src/components/Typography';

import { Checkbox, CheckboxProps } from '../../../components/Checkbox';


interface FormCheckboxExtraProps {
  name: string;
  caption?: ReactNode;
  tooltip?: string;
}

type FormCheckboxProps = CheckboxProps &
  FormCheckboxExtraProps &
  FieldHookConfig<boolean>;

export const FormCheckbox: React.FC<FormCheckboxProps> = (props) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;
  const { onChange, tooltip } = props;

  return (
    <Stack spacing={0.5}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Checkbox
          {...field}
          size="small"
          checked={field.value}
          {...props}
          onChange={(event) => {
            setValue(event.target.checked);
            if (onChange) onChange(event, event.target.checked);
          }}
        />
        {tooltip && (
          <Tooltip title={tooltip}>
            <Icon icon={faQuestionCircle} />
          </Tooltip>
        )}
      </Stack>
      {props.caption &&
        (typeof props.caption === 'string' ? (
          <HtmlTypography variant="body2" color="text.secondary">
            {props.caption}
          </HtmlTypography>
        ) : (
          props.caption
        ))}
      {meta.touched && meta.error && (
        <Typography variant="caption" color="error">
          {meta.error}
        </Typography>
      )}
    </Stack>
  );
};
